import { SNIPPET_REMOTE_ACTION_MAP_KEY } from 'flow/service/actionOptions';

export enum WorkflowEngineExceptionType {
  ERR_INITIALIZESCHEMA_NO_SCHEMA = 'ERR_INITIALIZESCHEMA_NO_SCHEMA',
  ERR_INITIALIZESCHEMA_FAILURE = 'ERR_INITIALIZESCHEMA_FAILURE',
}

export enum WorkflowTransformationIssueType {
  NO_MATCHING_TAG_FOUND_IN_CUSTOMER = 'NO_MATCHING_TAG_FOUND_IN_CUSTOMER',
  NO_MATCHING_SERVICE_FOUND_IN_CUSTOMER = 'NO_MATCHING_SERVICE_FOUND_IN_CUSTOMER',
  NO_MATCHING_OUTCOME_FOUND_IN_CUSTOMER = 'NO_MATCHING_OUTCOME_FOUND_IN_CUSTOMER',
  NO_TYPE_MATCHED = 'NO_TYPE_MATCHED',
  MATCHING_SERVICE_DISABLED_FOR_CUSTOMER = 'MATCHING_SERVICE_DISABLED_FOR_CUSTOMER',
  NO_MATCHING_LIST_ID_IN_CUSTOMER = 'NO_MATCHING_LIST_ID_IN_CUSTOMER',
  MATRIX_MODEL_NOT_SUPPORTED_AS_RHS_ACTION = 'MATRIX_MODEL_NOT_SUPPORTED_AS_RHS_ACTION',
}

export enum WorkflowImportUpdateResultType {
  RULE_UPDATED = 'RULE_UPDATED',
  EXPRESSION_UPDATED = 'EXPRESSION_UPDATED',
  LIST_ID_UPDATED = 'LIST_ID_UPDATED',
}

export enum WorkflowOperationType {
  UNDO_PERFORMED = 'UNDO_PERFORMED',
  AMBIGUOUS_RULE_FOUND = 'AMBIGUOUS_RULE_FOUND',
  CANCEL_PENDING_RULE_GROUP = 'CANCEL_PENDING_RULE_GROUP',
}

export const inputOutputAttributeActionOptionKeys = [
  'publishedAttributeToken',
  'name',
  'data_type',
  'use_jq',
  'jq_function',
];

export const outputAttributeActionOptionKeys = [
  'expression',
  'jq_function',
];

export const matrixModelActionOptionKeys = [
  'data_route_x',
  'data_route_y',
  'matrix_model_public_version',
  'matrix_model_token',
];

export const importedDataPassingActionOptionKeys = [
  'name',
  'display_name',
  'data_type',
  'use_jq',
];

export const snippetChildActionOptionKeys = [
  SNIPPET_REMOTE_ACTION_MAP_KEY,
];

export const booleanRuleStrings = {
  GROUP_START: '(',
  GROUP_END: ')',
  AND_OPERATOR: '&',
  OR_OPERATOR: '|',
  AND_OPERATOR_STRING: 'and',
  OR_OPERATOR_STRING: 'or',
};

export enum DependencyType {
  LEFT_SIDE_CONDITION = 'leftSideCondition',
  RIGHT_SIDE_CONDITION = 'rightSideCondition',
  DATA_ROUTE_SOURCE = 'dataRouteSource',
  // unused for now
  DATA_ROUTE_TARGET = 'dataRouteTarget',
}

export enum ExpressionUpdateType {
  ADDITION = 'ADDITION',
  INSERTION = 'INSERTION',
}

export enum ExpressionOperatorString {
  PLUS = '+',
  MINUS = '-',
  MULTIPLY = '*',
  DIVIDE = '/',
}

export enum ActionType {
  // deprecated feature we support for old workflows only
  EXIT = 'exit',
  IMPORTED_MATRIX_MODEL = 'imported_matrix_model',
  IMPORTED_OUTPUT_ATTRIBUTE = 'imported_output_attribute',
  INPUT = 'input',
  MATRIX_MODEL = 'matrix_model',
  OUTCOME = 'outcome',
  // explicitly imported outcome reasons, _not_ Tags with outcomes
  OUTCOME_REASON = 'outcome_reason',
  OUTPUT = 'output',
  /**
   * used by the frontend only - preview actions are the ones that get built
   * through a linked parent action
   */
  PREVIEW = 'preview',
  // container Action for a linked snippet
  SNIPPET = 'snippet',
  SERVICE = 'service',
  TAG = 'tag',
  // used for legacy routers only
  WORKFLOW = 'workflow',
}

export enum AggregationType {
  COUNT = 'COUNT',
  SUM = 'SUM',
  AVG = 'AVG',
  MIN = 'MIN',
  MAX = 'MAX',
  COUNT_DISTINCT = 'COUNT DISTINCT',
}

export enum TimeframeUnit {
  MINUTES = 'minutes',
  HOURS = 'hours',
  DAYS = 'days',
  MONTHS = 'months',
}

export enum MatrixModelDataType {
  NUMBER = 'number',
  STRING = 'string',
}

export const OUTPUT_CATEGORY_RISK_SCORING = 'Risk Scoring';
